import { useEffect, useState } from 'react';
import { fetchMissingObjectTypeKPI } from '../api/missingObjectTypeApi';

export const useMissingObjectTypeKpi = (activeFile = null, options = {}) => {
  const { batchData } = options;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = async (fileType) => {
    setLoading(true);
    setError(null);
    try {
      const effectiveFileType = fileType ?? activeFile ?? null;

      // Check if we have batch data available (preferred for performance)
      if (batchData && typeof batchData === 'object' && batchData.missing_object_types) {
        console.info('useMissingObjectTypeKpi: Using batch data for missing object types KPI');
        setData(batchData.missing_object_types);
        return;
      }

      // Fallback to individual API call if no batch data available
      console.info('useMissingObjectTypeKpi: Falling back to individual API call');
      const kpi = await fetchMissingObjectTypeKPI(effectiveFileType);
      setData(kpi);
    } catch (e) {
      setError(e?.message || 'Failed to load KPI');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        // Check if we have batch data available (preferred for performance)
        if (batchData && typeof batchData === 'object' && batchData.missing_object_types) {
          console.info('useMissingObjectTypeKpi: Using batch data for missing object types KPI');
          if (!cancelled) setData(batchData.missing_object_types);
          setLoading(false);
          return;
        }

        // Fallback to individual API call if no batch data available
        console.info('useMissingObjectTypeKpi: Falling back to individual API call');
        const kpi = await fetchMissingObjectTypeKPI(activeFile ?? null);
        if (!cancelled) setData(kpi);
      } catch (e) {
        if (!cancelled) setError(e?.message || 'Failed to load KPI');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, [activeFile, batchData]);

  return { data, loading, error, refresh: load };
};
